import React from 'react';

const ProgressBar = ({ value = 0, max = 100 }) => {
  const clampedValue = Math.min(Math.max(value, 0), max);
  const percentage = (clampedValue / max) * 100;

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-fill" style={{ width: `${percentage}%` }}>
      </div>
    </div>
  );
};

export default ProgressBar;



